import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IUserSlice, TCart, TUser } from "@/redux/slices/user/types";

export const getUser = createAsyncThunk(
  "user/getUser",
  async () => await axios.get("/api/customer").then((res) => res.data)
);

const pending = (state: IUserSlice) => {
  state.user.loading = true;
  state.cart.loading = true;
};

const fulfilled = (
  state: IUserSlice,
  { payload }: { payload: { user: TUser; cart: TCart } }
) => {
  state.user = {
    ...state.user,
    loading: false,
    ...payload.user,
  };
  state.cart = {
    ...payload.cart,
    loading: false,
    uuid: payload.cart?.uuid || state.cart?.uuid,
    items: payload.cart?.items?.map((item) => ({
      ...item,
      loading: false,
    })),
  };
};

const rejected = (state: IUserSlice) => {
  state.user.loading = false;
  state.cart.loading = false;
};

export default {
  action: getUser,
  pending,
  fulfilled,
  rejected,
};
